import { KeenSliderInstance } from 'keen-slider';
import { KeenSliderHooks } from 'keen-slider/react';
import { MutableRefObject } from 'react';
import classNames from 'classnames';
import { DotsType } from './types';
interface Props {
  instanceRef: MutableRefObject<KeenSliderInstance<object, object, KeenSliderHooks> | null>; //@typescript-eslint/ban-types
  currentSlide: number;
  dotsType: DotsType;
}
const Dots = ({
  instanceRef,
  currentSlide,
  dotsType
}: Props) => {
  const dotsArray = [...Array(instanceRef.current?.track.details.slides.length).keys()];
  if (dotsArray.length <= 1) return null;
  return <div className={classNames('absolute flex -translate-x-1/2 items-center justify-center lg:pb-4', {
    'bottom-0 left-1/2 pb-2': dotsType === DotsType.HomePage,
    'right-[200px] top-0 pt-2 lg:hidden': dotsType === DotsType.PDP
  })} data-sentry-component="Dots" data-sentry-source-file="dots.tsx">
            {dotsArray.map(idx => {
      return <span key={idx} onClick={() => {
        instanceRef.current?.moveToIdx(idx);
      }} className={classNames('ml-1 cursor-pointer border-0', {
        'h-1 w-1 rounded-[1px]': currentSlide !== idx,
        'h-1.5 w-4 rounded-sm': currentSlide === idx
      }, dotsType === DotsType.HomePage && {
        'bg-gray-500': currentSlide !== idx,
        'bg-surface-scrim-white': currentSlide === idx
      }, dotsType === DotsType.PDP && {
        'bg-border-gray-medium': currentSlide !== idx,
        'bg-surface-scrim-black': currentSlide === idx
      })} />;
    })}
        </div>;
};
export default Dots;